import React, { Component } from 'react';
import { compose } from 'redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';

import { H5, TextInput, Button, Container, ConfirmationBox } from '../../components/index.js';
import Grid from '../../components/grid/Grid.js';
import listUsersGridConfig, { autoGroupColumnDefForAdd } from '../../configs/gridConfigs/licencee/listUsersGridConfig.js';
import { toggleAddMaterailModal } from '../../actions/trfActions.js';
import { clearEditLocationList } from '../../actions/adminUserActions.js';
import { createServiceAction } from '../../util/actionHelper.js';
import { history } from '../../util/index.js';
import { getLicenseeList } from '../../reducers/licenseeReducer.js';
import ListLicensees from './listLicensees/listLicensees.js';


class AddLicensee extends Component {

    constructor(props) {
        super(props);
        this.state = {
            submitModal: false,
            selectedNodes: [],
            selectedNodesOnDefault: [],
            activeNewLicenseeAdd: true,
            activelistLicensee: false,
            statusChanged: false,
            supName: null,
            initialStateSave: true,
            updateCheckBoxArry: [],
            selectedIds: [], // To store selected user IDs
            isLoader: false,
            hasAutoSelected: false,
        };

        this.confirmationBoxOpen = this.confirmationBoxOpen.bind(this);
        this.setLicensee = this.setLicensee.bind(this);
        this.setGridParams = this.setGridParams.bind(this);
        this.cancelAddLicensee = this.cancelAddLicensee.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);

    }
    componentDidMount() {
        const { clearEditLocationList } = this.props;
        clearEditLocationList();
        this.setState({ supName: null });
    }

    componentDidUpdate(prevProps) {
        const { licenceeList } = this.props;
        const { hasAutoSelected , selectedNodesOnDefault, selectedNodes} = this.state;
        // If licenceeList changed after update, reset auto-select flag
        if (prevProps.licenceeList !== licenceeList) {
            this.setState({ hasAutoSelected: false, isLoader: false });
        }
        if (
            !hasAutoSelected &&
            !isEmpty(licenceeList)
        ) {
            setTimeout(() => {
                this.params && this.params.api.forEachNode(function (node) {
                    if (node.data && node.data.isLicensee) {
                        node.setSelected(true);
                    }
                });
                this.setState({ hasAutoSelected: true });
            }, 0);
            if (this.params && this.params.api.getSelectedRows()) {
                const selectedRows = this.params.api.getSelectedRows();
                // Only update state if values have changed to avoid infinite loop
                if (
                    !isEqual(selectedNodesOnDefault, selectedRows) ||
                    !isEqual(selectedNodes, selectedRows)
                ) {
                    this.setState({ selectedNodesOnDefault: selectedRows, selectedNodes: selectedRows });
                }
            }
        }
    }


    newLicenseeAdd = status => this.setState({ supName:null, activeNewLicenseeAdd: status, activelistLicensee: false, statusChanged: status });

    listLicenseeButton = status => this.setState({ supName:null, activeNewLicenseeAdd: false, activelistLicensee: status, statusChanged: false });

    confirmationBoxOpen = () => this.setState({ submitModal: true });

    closeSubmitModal = () => this.setState({ submitModal: false });


    onSelectionChanged = (_) => {
        const selectedRows = this.params.api.getSelectedRows();
        const selectedIds = selectedRows.map(row => row.userId); // Use your unique key
        this.setState({ selectedNodes: selectedRows, selectedIds });

    };
    setLicensee = selectedNodes => {
        const { setLicenseeInfo, licenceeList } = this.props;
        const { supName } = this.state;
        const selectedIds = selectedNodes.map(item => item.userId);
        const updatedNodes = (licenceeList || []).map(item => ({
            ...item,
            isLicensee: selectedIds.includes(item.userId)
        }));
        const UpdatedSelectedNodes = updatedNodes
            .map(item => ({
                supName,
                userId: item.userId,
                isActive: item.isLicensee
            }));
        setLicenseeInfo({ users: UpdatedSelectedNodes, listParams: { searchSup: supName, isAll: true } });
    }

    licenseeListRequest = supName => {
        if (supName && supName.length >= 3) {
        const { requestLicenseeList } = this.props;
        let selectedIds = [];
        if (this.params && this.params.api) {
            const selectedRows = this.params.api.getSelectedRows();
            selectedIds = Array.isArray(selectedRows) ? selectedRows.map(row => row.userId) : [];
        }
        this.setState({ supName, selectedIds, hasAutoSelected: false }, () => {
            requestLicenseeList(supName);
        });
        this.setState({ isLoader: true })
    }
    };

    cancelAddLicensee = () => {
        history.push('/');
    };

    setGridParams = params => {
        this.params = params;
        /* params && params.api.forEachNode(function (node) {
            if (node.data && node.data.isLicensee) {
                node.setSelected(true);
            }
        }); */
        if (params) {
            this.setState({ selectedNodesOnDefault: params.api.getSelectedRows() })
        }
    }
    getSortedIdsString = arr => (arr || []).map(x => x.userId).sort().join(',');

    render() {
        const { licenceeList, addLicenseeForm } = this.props;
        const { activeNewLicenseeAdd, activelistLicensee, submitModal, selectedNodes, supName } = this.state;
        return (
            <div >
            <Container section className="ml1-sm mr1-sm mt2-sm tab-class-container tab-class">
                <div className="ncss-col-sm-12 ncss-input-container">
                <div className="ncss-col-sm-10 align-left">
                    <div className="pb2-sm" >
                    <div className="ncss-col-sm-12 pb3-sm supplier_class">
                        <div className="ncss-col-sm-6 p2-sm">
                        <Button className={`supplier-add-new-button add-supplier-text u-bold ${activeNewLicenseeAdd ? 'active-supplier-button ' : 'not-active-supplier-button'}`}
                            onClick={() => this.newLicenseeAdd(true)}>
                            <i className="fas fa-address-card"></i> Add Licensees
                        </Button>
                        <span className="span_addsupplier"> | </span>

                        <Button className={`supplier-add-new-button add-supplier-text u-bold ${activelistLicensee ? 'active-supplier-button ' : 'not-active-supplier-button'} `}
                            onClick={() => this.listLicenseeButton(true)}>
                            <i className="fas fa-user-edit"></i>  Show Licensees
                        </Button>
                        </div>
                    </div>
                    {activeNewLicenseeAdd ?
                        <span>
                        <span>
                            <div className="ncss-col-sm-2 inline-flex-display">
                            <H5 className="u-bold description p2-top-sm p2-bottom-sm add-supplier-text">Licensee Name<span className="mandatory_supplier"></span></H5>
                            </div>
                            <div className="ncss-col-sm-4 ncss-input-container inline-flex-display no-padding-supplier">
                            <Field component={TextInput} name="supplierName" type="text" containerClass="u-full-width" />
                            </div>
                            <div className="ncss-col-sm-2 ncss-input-container inline-flex-display">
                            {addLicenseeForm && addLicenseeForm.supplierName && addLicenseeForm.supplierName.length >= 3 ?
                                <Button className="ncss-btn-grey u-bold add-supplier-search add-supplier-search-color ncss-input pt2-sm pr4-sm pb2-sm pl4-sm"
                                onClick={
                                    () => this.licenseeListRequest(addLicenseeForm && addLicenseeForm.supplierName)
                                }>
                                <i className="fas fa-search" />
                                Search
                                </Button>
                                :
                                <Button className="ncss-btn-grey u-bold add-supplier-search  pt2-sm pr4-sm pb2-sm pl4-sm disabled " disabled>
                                <i className="fas fa-search" />
                                Search
                                </Button>
                            }
                            </div>
                        </span>

                        {licenceeList && supName!=="" && supName!==null ?
                            <div className="pt2-sm ncss-col-sm-offset-2 ncss-col-sm-11 pl0-sm">
                            <Grid
                                columnDefs={listUsersGridConfig}
                                rowData={licenceeList && licenceeList.length > 0 ? licenceeList : []}
                                setParams={this.setGridParams}
                                rowSelection="multiple"
                                onGridReady={(params) => (this.gridApi = params.api)}
                                onSelectionChanged={this.onSelectionChanged}
                                autoGroupColumnDef={autoGroupColumnDefForAdd}
                                groupSelectsChildren={true}
                                suppressRowClickSelection={true}
                            />
                            </div>
                            :
                            <div className="grid-height-adjust"></div>
                        }
                        </span>
                        :
                        <span>
                        < ListLicensees />
                        </span>
                    }
                    </div>
                    <div>
                    </div>
                </div>
                </div>
            </Container>

            <div className="ncss-col-sm-12 ">
                <div className="ncss-col-sm-12 align-center">
                <Button className="ncss-btn-secondary-dark u-bold secondary-button add-supplier-location-buttton"
                    onClick={this.cancelAddLicensee}>
                    CANCEL
                </Button>
                 {/* {activeNewLicenseeAdd && licenceeList && supName && licenceeList.length > 0 ?
                    <Button
                    className="ncss-btn-grey u-bold new-material update-exception-buttton"
                    onClick={() => this.confirmationBoxOpen()}
                    >
                    UPDATE LICENSEES
                    </Button>
                    : null} */ }
                </div>
            </div>
            <ConfirmationBox
                message={
                `Are you sure you want to update the licensee list?`

                }
                submitModal={submitModal}
                submitValue={
                () => {
                    this.setState({ isLoader: true });
                    this.setLicensee(selectedNodes);
                }

                }
                closeModal={this.closeSubmitModal}
            />
            </div>
        );
    }
}

AddLicensee.propTypes = {
    toggleAddMaterailModal: PropTypes.func,
    isAddMaterialModalOpen: PropTypes.bool,
    requestSupplierList: PropTypes.func,
    history: PropTypes.object
};
const mapStateToProps = state => ({
    allData: state,
    isAddMaterialModalOpen: state.trf.isAddMaterialModalOpen,
    supplierData: state.adminUser.supplierData,
    licenseeData: state.licensee.licenseeDetails,
    supplierLocationList: state.adminUser.supplierLocationList,
    locationDetails: state.adminUser.locationDetails,
    addLicenseeForm: getFormValues('addLicensee')(state),
    errorStatusAddLicensee: state.adminUser.errorStatusAddLicensee,
    errorStatusUpdateSupplier: state.adminUser.errorStatusUpdateSupplier,
    licenceeList: getLicenseeList(state)
});

const mapDispatchToProps = dispatch => ({
    toggleAddMaterailModal: isOpen => {
        dispatch(toggleAddMaterailModal(isOpen));
    },
     clearEditLocationList: () => {
        dispatch(clearEditLocationList());
    },
    submitSupplierData: (data) => {
        dispatch(createServiceAction('addLicensee', 'submited')({ ...data }));
    },

    setLicenseeInfo: (data) => {
        dispatch(createServiceAction('setLicensee', 'requested')({ ...data }));
    },

    requestLicenseeList: searchTerm => {
        dispatch(createServiceAction('listLicensee', 'requested')({ searchSup: searchTerm, isAll: true }));
    },

    licenseeListFetch: searchTerm => {
        dispatch(createServiceAction("listLicensee", 'requested')({ searchSup: searchTerm, isAll: true }))
    }

});

export default compose(reduxForm({ form: 'addLicensee' }),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(AddLicensee);